export const conditionOptions = [
  { value: 'new_with_tags', label: 'New with tags' },
  { value: 'like_new', label: 'Like new' },
  { value: 'great', label: 'Great' },
  { value: 'good', label: 'Good' },
];

export const countryOptions = [
  { value: 'Germany', label: 'Germany' },
  { value: 'Switzerland', label: 'Switzerland' },
];

export const countryCodeMap = {
  Germany: 'DE',
  Switzerland: 'CH',
};
